import { Modal } from "antd";
import React from "react";
import DocumentViewer from "../../../components/DocumentViewer";
import { useSelector, useDispatch } from "react-redux";
import { UpdateUserPreferences } from "../../../redux/actions/account-action-types";
import { DocumentIcon, EyeIcon } from "./SVGs";
import AreaBookmark from "../../../components/AreaBookmark";
import translator from "../../../utilities/translator";
import ExamShareModal from "../../../components/base/ExamShareModal";
export default function ReviewTopMenuButtonPanels({
	bundledExams,
	enableMainImages,
	changeShowMainImages,
	showMainImages,
	enableReport,
	changeShowReport,
	showReport,
	enableDocuments,
	changeShowDocuments,
	showDocuments,
	selectedExam,
}) {
	const dispatch = useDispatch();
	const userPreferences = useSelector(
		(state) => state?.session?.userPreferences
	);
	const currentLanguage = userPreferences?.language;
	let selectedExamObj = selectedExam;
	const [showExamShareModal, setShowExamShareModal] = React.useState(false);

	return (
		<div className="div-divider  d-flex flex-row border-div size-viewsec">
			<ExamShareModal
				showExamShareModal={showExamShareModal}
				setShowExamShareModal={setShowExamShareModal}
				currentSelectedExam={selectedExamObj}
				onCancel={() => {
					setShowExamShareModal(false);
				}}
				bodyStyle={{
					padding: "20px 24px",
					height: "auto",
					maxHeight: "70vh",
					overflowY: "auto",
					borderRadius: "12px",
				}}
			/>
			<Modal
				open={showDocuments}
				title="Documents"
				onOk={() => {
					if (changeShowDocuments) changeShowDocuments(false);
				}}
				onCancel={() => {
					if (changeShowDocuments) changeShowDocuments(false);
				}}
				zIndex={5000}
				className="custom-modal matching-modal headerborder-0 modal-width modal-dialog"
				width="1000px"
			>
				<div style={{ position: "relative" }}>
					<AreaBookmark
						active={userPreferences?.examEditorRequestOpen ?? false}
						onChange={async (e) => {
							dispatch(
								UpdateUserPreferences({
									data: {
										examEditorRequestOpen:
											!userPreferences?.examEditorRequestOpen,
									},
									callback: () => {},
								})
							);
						}}
					/>
					<DocumentViewer bundledExams={bundledExams} />
				</div>
			</Modal>
			<ul
				className="navbar-nav"
				style={{
					display: "flex",
					alignItems: "center",
					gap: "1px",
				}}
			>
				{enableMainImages && (
					<li className="nav-item dropdown circle-icon">
						<div style={{ position: "relative" }}>
							<button
								//disabled={!bundledExams[0].hasImages}
								onClick={async (e) => {
									if (changeShowMainImages) {
										changeShowMainImages(!showMainImages, null);
									}
								}}
								style={{
									background: showMainImages ? "#e78e4b" : "#ffffff",
									color: showMainImages ? "#fff" : "#05585E",
									border: showMainImages
										? "2px solid #e78e4b"
										: "2px solid #e78e4b",

									borderRadius: "8px",
									padding: "8px 12px",
									cursor: "pointer",
									display: "inline-flex",
									alignItems: "center",
									justifyContent: "center",
									transition: "all 0.2s",
									outline: "none",
									boxShadow: "0 4px 6px rgba(0,0,0,0.15)",
									opacity: 1,
									marginRight: "1px",
								}}
								title={translator(currentLanguage, "images")}
								onMouseOver={(e) => {
									e.currentTarget.style.background = showMainImages
										? "#d97a3a"
										: "#EBB994";
								}}
								onMouseOut={(e) => {
									e.currentTarget.style.background = showMainImages
										? "#e78e4b"
										: "#fff";
								}}
							>
								<i
									className="zmdi zmdi-eye zmdi-hc-2x"
									style={{
										fontSize: "1em",
										color: "#05585E",
									}}
								/>
							</button>
						</div>
					</li>
				)}
				{enableReport && (
					<li className="nav-item dropdown circle-icon">
						<div style={{ position: "relative" }}>
							<button
								//disabled={!bundledExams[0].hasImages}
								onClick={async (e) => {
									if (changeShowReport) {
										changeShowReport(!showReport, null);
									}
								}}
								style={{
									background: showReport ? "#e78e4b" : "#ffffff",
									color: showReport ? "#fff" : "#05585E",
									border: showReport
										? "2px solid #e78e4b"
										: "2px solid #e78e4b",

									borderRadius: "8px",
									padding: "8px 12px",
									cursor: "pointer",
									display: "inline-flex",
									alignItems: "center",
									justifyContent: "center",
									transition: "all 0.2s",
									outline: "none",
									boxShadow: "0 4px 6px rgba(0,0,0,0.15)",
									opacity: 1,
									marginRight: "1px",
								}}
								title={translator(currentLanguage, "report")}
								onMouseOver={(e) => {
									e.currentTarget.style.background = showReport
										? "#d97a3a"
										: "#EBB994";
								}}
								onMouseOut={(e) => {
									e.currentTarget.style.background = showReport
										? "#e78e4b"
										: "#fff";
								}}
							>
								<i
									className="zmdi zmdi-file"
									style={{
										fontSize: "1em",
										color: "#05585E",
									}}
								/>
							</button>
						</div>
					</li>
				)}
				{enableDocuments && (
					<li className="nav-item dropdown circle-icon">
						<button
							onClick={async (e) => {
								if (changeShowDocuments) changeShowDocuments(true);
							}}
							style={{
								background: "#ffffff",
								border: "2px solid #e78e4b",
								borderRadius: "8px",
								padding: "8px 12px",
								cursor: "pointer",
								display: "inline-flex",
								alignItems: "center",
								justifyContent: "center",
								transition: "all 0.2s",
								outline: "none",
								boxShadow: "0 4px 6px rgba(0,0,0,0.15)",
								opacity: 1,
								marginRight: "14px",
							}}
							title={translator(currentLanguage, "documents")}
							onMouseOver={(e) => {
								e.currentTarget.style.background = "#EBB994"; // hover mais vivo
								e.currentTarget.style.boxShadow = "0 6px 10px rgba(0,0,0,0.2)";
								e.currentTarget.style.transform = "translateY(-2px)";
							}}
							onMouseOut={(e) => {
								e.currentTarget.style.background = "#fff";
								e.currentTarget.style.boxShadow = "0 4px 6px rgba(0,0,0,0.15)";
								e.currentTarget.style.transform = "translateY(0)";
							}}
							onMouseDown={(e) => {
								e.currentTarget.style.transform = "translateY(1px) scale(0.95)";
								e.currentTarget.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)";
							}}
							onMouseUp={(e) => {
								e.currentTarget.style.transform = "translateY(-2px) scale(1)";
								e.currentTarget.style.boxShadow = "0 6px 10px rgba(0,0,0,0.2)";
							}}
						>
							<i
								className="zmdi zmdi-attachment-alt"
								style={{
									fontSize: "1em",
									color: "#05585E",
								}}
							/>
						</button>
					</li>
				)}
				<li className="nav-item dropdown circle-icon">
					<button
						onClick={(e) => {
							e.preventDefault();
							setShowExamShareModal(true);
						}}
						title={translator(currentLanguage, "share")}
						style={{
							background: "#ffffff",
							border: "2px solid #e78e4b",
							borderRadius: "8px",
							padding: "8px 12px",
							cursor: "pointer",
							display: "inline-flex",
							alignItems: "center",
							justifyContent: "center",
							transition: "all 0.2s",
							outline: "none",
							boxShadow: "0 4px 6px rgba(0,0,0,0.15)",
							opacity: 1,
							marginRight: "14px",
						}}
						onMouseOver={(e) => {
							e.currentTarget.style.background = "#EBB994"; // hover mais vivo
							e.currentTarget.style.boxShadow = "0 6px 10px rgba(0,0,0,0.2)";
							e.currentTarget.style.transform = "translateY(-2px)";
						}}
						onMouseOut={(e) => {
							e.currentTarget.style.background = "#fff";
							e.currentTarget.style.boxShadow = "0 4px 6px rgba(0,0,0,0.15)";
							e.currentTarget.style.transform = "translateY(0)";
						}}
						onMouseDown={(e) => {
							e.currentTarget.style.transform = "translateY(1px) scale(0.95)";
							e.currentTarget.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)";
						}}
						onMouseUp={(e) => {
							e.currentTarget.style.transform = "translateY(-2px) scale(1)";
							e.currentTarget.style.boxShadow = "0 6px 10px rgba(0,0,0,0.2)";
						}}
					>
						<i
							className="zmdi zmdi-share"
							style={{
								fontSize: "1em",
								color: "#05585E",
							}}
						/>
					</button>
				</li>
			</ul>
		</div>
	);
}
